<template>
    <ValidationObserver ref="graduationClearanceForm">
        <b-container class="mt-5">
            <b-card class="p-5">
                <b-row class="text-center align-items-center mb-4">
                    <b-col
                        cols="12"
                        class="d-flex align-items-center justify-content-between"
                    >
                        <img
                            src="../../../assets/img/BAU_Logo.png"
                            height="75"
                            alt="BAU Logo"
                        />
                        <h6
                            class="mb-0"
                            v-html="$t('bau_inspiration_text')"
                        ></h6>
                    </b-col>
                </b-row>
                <div class="mb-4">
                    <h4 class="text-center font-weight-bold">
                        {{ $t("graduation_clearance_form") }}
                    </h4>
                    <p v-html="$t('graduation_clearance_subtitle')"></p>
                </div>

                <!-- Student Information -->
                <b-row class="mb-3">
                    <b-col cols="12">
                        <h5 class="font-weight-bold">
                            {{ $t("student_information") }}
                        </h5>
                        <hr class="yellow-line" />
                    </b-col>
                    <b-col cols="12">
                        <ValidationProvider
                            name="first_name"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('student_name')">
                                <b-form-input
                                    v-model="form.student_name"
                                    :state="
                                        errors[0] ? false : valid ? true : null
                                    "
                                />
                                <b-form-invalid-feedback
                                    v-if="errors[0]"
                                    v-html="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="4">
                        <ValidationProvider
                            name="phone"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('phone')">
                                <b-form-input
                                    v-model="form.phone"
                                    :state="
                                        errors[0] ? false : valid ? true : null
                                    "
                                />
                                <b-form-invalid-feedback
                                    v-if="errors[0]"
                                    v-html="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="4">
                        <ValidationProvider
                            name="email"
                            rules="required|email"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('email')">
                                <b-form-input
                                    v-model="form.email"
                                    :state="
                                        errors[0] ? false : valid ? true : null
                                    "
                                />
                                <b-form-invalid-feedback
                                    v-if="errors[0]"
                                    v-html="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="4">
                        <ValidationProvider
                            name="student_id"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('student_id')">
                                <b-form-input
                                    v-model="form.student_id"
                                    :state="
                                        errors[0] ? false : valid ? true : null
                                    "
                                />
                                <b-form-invalid-feedback
                                    v-if="errors[0]"
                                    v-html="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <hr class="yellow-line" />

                <!-- Faculty Section -->
                <b-row class="mb-3 mt-4">
                    <b-col cols="12">
                        <h5 class="font-weight-bold">Faculty</h5>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider
                            name="faculty_signature"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('signature')">
                                <b-form-input
                                    v-model="form.faculty_signature"
                                    :state="
                                        errors[0] ? false : valid ? true : null
                                    "
                                />
                                <b-form-invalid-feedback
                                    v-if="errors[0]"
                                    v-html="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider
                            name="faculty_date"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('date')">
                                <select-date
                                    v-model="form.faculty_date"
                                    :validation-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <hr class="yellow-line" />

                <!-- Registrar Section -->
                <b-row class="mb-3 mt-4">
                    <b-col cols="12">
                        <h5 class="font-weight-bold">{{ $t("registrar") }}</h5>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider
                            name="registrar_signature"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('signature')">
                                <b-form-input
                                    v-model="form.registrar_signature"
                                    :state="
                                        errors[0] ? false : valid ? true : null
                                    "
                                />
                                <b-form-invalid-feedback
                                    v-if="errors[0]"
                                    v-html="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider
                            name="registrar_date"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('date')">
                                <select-date
                                    v-model="form.registrar_date"
                                    :validation-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <hr class="yellow-line" />

                <!-- Bursar Section -->
                <b-row class="mb-3 mt-4">
                    <b-col cols="12">
                        <h5 class="font-weight-bold">{{ $t("bursar") }}</h5>
                        <p>{{ $t("bursar_note") }}</p>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider
                            name="bursar_signature"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('signature')">
                                <b-form-input
                                    v-model="form.bursar_signature"
                                    :state="
                                        errors[0] ? false : valid ? true : null
                                    "
                                />
                                <b-form-invalid-feedback
                                    v-if="errors[0]"
                                    v-html="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider
                            name="bursar_date"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('date')">
                                <select-date
                                    v-model="form.bursar_date"
                                    :validation-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <hr class="yellow-line" />

                <!-- Footer -->
                <b-row>
                    <b-col>
                        <p class="text-center font-weight-bold mt-4">
                            {{ $t("graduation_clearance_footer_note") }}
                        </p>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
    </ValidationObserver>
</template>

<script>
import SelectDate from "@/components/interactive-fields/SelectDate.vue";

export default {
    components: { SelectDate },
    data() {
        return {
            form: {
                student_name: null,
                phone: null,
                email: null,
                student_id: null,
                faculty_signature: null,
                faculty_date: null,
                registrar_signature: null,
                registrar_date: null,
                bursar_signature: null,
                bursar_date: null,
            },
        };
    },
    metaInfo() {
        return {
            title: this.$t("graduation_clearance_form"),
        };
    },
};
</script>

<style scoped>
.yellow-line {
    border-top: 2px solid #ffc107; 
    margin: 1rem 0;
}
</style>
